var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfilePortfolioInner.jinja');
require('./MemberProfilePortfolioInner.less');

var MemberProfileButtonsEdit = require('front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit');
var CommonVideoPlayer = require('front/components/CommonVideoPlayer/CommonVideoPlayer');


var objectFitImages = require('object-fit-images');

require('assets/owl.carousel.min.css');
require('assets/owl.theme.default.min.css');
require('owl.carousel.min-2.2.1.js');

module.exports = Base.extend({

    template: template,

    CAPTION_FADE_DURATION: 250,

    events: {
        'click .MemberProfilePortfolioInner-content-createPortfolio-btn': 'openEdit',
        'click .MemberProfilePortfolioInner-mainGalleryCarouselItem': 'openFullscreen',
        'click .MemberProfilePortfolioInner-mainGalleryWrapperClose': 'closeFullscreen'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onNavHidden', 'onNavVisible', 'onKeyDown');

        this.MemberProfileButtonsEdit = new MemberProfileButtonsEdit({
            el: this.$el.parent().find('.MemberProfileButtonsEdit')[0]
        });

        Base.prototype.initialize.call(this, options);

        window.app.vent.on('nav-hidden', this.onNavHidden);
        window.app.vent.on('nav-visible', this.onNavVisible);

        $('body').on('keydown', this.onKeyDown);
    },


    deactivate: function (params) {
        $('body').off('keydown', this.onKeyDown);

        this.MemberProfileButtonsEdit.deactivate();
        delete this.MemberProfileButtonsEdit;

        window.app.vent.off('nav-hidden', this.onNavHidden);
        window.app.vent.off('nav-visible', this.onNavVisible);

        return Base.prototype.deactivate.call(this, params);
    },


    onKeyDown: function (e) {
        if (this.$('.MemberProfilePortfolioInner-mainGalleryWrapper').attr('data-state') != 'fullscreen') return;

        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.closeFullscreen();
        }
    },

    onNavHidden: function () {
        this.$('.MemberProfilePortfolioInner-mainGalleryWrapperClose').addClass('MemberProfilePortfolioInner-mainGalleryWrapperClose--nav-hidden');
    },


    onNavVisible: function () {
        this.$('.MemberProfilePortfolioInner-mainGalleryWrapperClose').removeClass('MemberProfilePortfolioInner-mainGalleryWrapperClose--nav-hidden');
    },


    activate: function () {

        var self = this;
        var itemsCount = this.$('.MemberProfilePortfolioInner-mainGalleryCarouselItem').length;
        var $mainGallery = this.$('.MemberProfilePortfolioInner-mainGalleryCarousel');
        var $thumbGallery = this.$('.MemberProfilePortfolioInner-thumbsGalleryCarousel');

        $mainGallery.owlCarousel({
            items: 1,
            nav: itemsCount > 1,
            dots: itemsCount > 1,
            loop: itemsCount > 1,
            dotsEach: Math.ceil(itemsCount / 10), //no more than 10 dots
            mouseDrag: false,
            smartSpeed: 500
        })
            .on('changed.owl.carousel', function (e) {
                if (this.prevInd != undefined) {
                    var $item = this.$('.MemberProfilePortfolioInner-mainGalleryCarouselItem').eq(this.prevInd);
                    var tp = $item.attr('data-component');
                    var instance = $item.data('data-instance');

                    if (tp == 'video' && instance) {
                        var $player = $item.find('.CommonVideoPlayer');
                        $player.trigger('pauseplayer');
                    }
                }
                this.checkVideoPlayer(e.item.index);//here is item index

                this.updateCaption(e.item.index); //here is item index

                var current = (e.item.index + 1) - e.relatedTarget._clones.length / 2;
                var allItems = e.item.count;
                if (current > allItems || current == 0) {
                    current = allItems - (current % allItems);
                }

                self.$('.MemberProfilePortfolioInner-thumbsGalleryCarouselItem.play').removeClass('play');
                self.$('.MemberProfilePortfolioInner-thumbsGalleryCarouselItem[data-ind="' + (current - 1) + '"]').addClass('play');//here is page index

                $thumbGallery.trigger('to.owl.carousel', [e.page.index, 500, true]);//here is page index
            }.bind(this));

        $mainGallery
            .find('.owl-prev')
            .html(this.$('.MemberProfilePortfolioInner-mainGalleryPrev').html());

        $mainGallery
            .find('.owl-next')
            .html(this.$('.MemberProfilePortfolioInner-mainGalleryNext').html());




        $thumbGallery.owlCarousel({
            items: 6,
            nav: false,
            dots: false,
            mouseDrag: false,
            smartSpeed: 500
        })
            .on('click', '.owl-item', function () {
                // On click of thumbnail items to trigger same main item
                $mainGallery.trigger('to.owl.carousel', [$(this).index(), 500, true]);
            });


        //lopp issues, first item is not 0
        var firstItem = this.$('.MemberProfilePortfolioInner-mainGallery .owl-item.active').index();

        this.checkVideoPlayer(firstItem);

        this.updateCaption(firstItem);

        objectFitImages();

        return Base.prototype.activate.call(this);
    },


    updateCaption: function (ind) {
        var $itemCaption = this.$('.MemberProfilePortfolioInner-mainGallery .owl-item')
            .eq(ind)
            .find('.MemberProfilePortfolioInner-mainGalleryCarouselItemCaption');
        var $galleryCaption = this.$('.MemberProfilePortfolioInner-mainGalleryCaption').eq(0);
        var $clone = $galleryCaption.clone();

        $clone
            .appendTo($galleryCaption.parent());

        $clone.fadeOut(this.CAPTION_FADE_DURATION, function () {
            $clone.remove();
        }.bind(this));

        if ($itemCaption.length) {
            $galleryCaption
                .html($itemCaption.html())
                .fadeOut(0)
                .fadeIn(this.CAPTION_FADE_DURATION);
        } else {
            $galleryCaption
                .empty()
                .fadeOut(0);
        }

        $galleryCaption.parent().height($galleryCaption.height());
    },

    checkVideoPlayer: function (ind) {
        var $item = this.$('.MemberProfilePortfolioInner-mainGalleryCarouselItem').eq(ind);
        var tp = $item.attr('data-component');
        var instance = $item.data('data-instance');

        if (tp == 'video' && !instance) {
            var $player = $item.find('.CommonVideoPlayer');
            instance = new CommonVideoPlayer({el: $player[0]});
            $item.data('data-instance', instance);
            $player.trigger('initplayer');
        }

        this.prevInd = ind;
    },


    openFullscreen: function () {
        var $mainGallery = this.$('.MemberProfilePortfolioInner-mainGalleryCarousel');

        if (this.$('.MemberProfilePortfolioInner-mainGalleryWrapper').attr('data-state') == 'fullscreen') return;

        this.$('.MemberProfilePortfolioInner-mainGalleryWrapper').attr('data-state', 'fullscreen');

        $mainGallery.data('owl.carousel')._invalidated.width = true;
        $mainGallery.trigger('refresh.owl.carousel');
    },


    closeFullscreen: function () {
        var $mainGallery = this.$('.MemberProfilePortfolioInner-mainGalleryCarousel');

        if (this.$('.MemberProfilePortfolioInner-mainGalleryWrapper').attr('data-state') == 'normal') return;

        this.$('.MemberProfilePortfolioInner-mainGalleryWrapper').attr('data-state', 'normal');

        $mainGallery.data('owl.carousel')._invalidated.width = true;
        $mainGallery.trigger('refresh.owl.carousel');
    },

    openEdit: function () {
        window.app.vent.trigger('MemberProfileEdit--open', 'portfolio');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfilePortfolioInner.js
// module id = 196
// module chunks = 0